import { useState, useEffect } from 'react';

import { Container, Row, Col } from '..';

import s from './GridHelper.module.scss';

const GridHelper = () => {
  const [columns, setColumns] = useState(12);
  useEffect(() => {
    const onResize = () => {
      setColumns(window.innerWidth < 768 ? 6 : 12);
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  return (
    <div className={s.gridHelper}>
      <Container className={s.h100}>
        <Row className={s.h100}>
          {Array(columns)
            .fill(1)
            .map((_, index) => (
              <Col key={index} className={s.h100}>
                <div className={s.gridColInner}></div>
              </Col>
            ))}
        </Row>
      </Container>
    </div>
  );
};

export default GridHelper;
